import classNames from 'classnames';
import * as React from 'react';
import { ActionButtonsContainer } from '../../../ActionButtons';
import { AutoProlongContainer } from '../../../AutoProlong';
import { CheckoutContainer } from '../../../Checkout';
import { MLSNPublicationBannerContainer } from '../../../MLSNPublicationBanner';
import { N1PublicationBannerContainer } from '../../../N1PublicationBanner';
import { VisibleViolationsWarningContainer } from '../../../VisibleViolationsWarning';
import * as styles from './SummaryMobile.css';
import { UIText1 } from '@cian/ui-kit';
import { Layout } from '../../../ServicePickerWidget/Layout';
import { BalanceMobile } from '../../../Balance';
import { MoneySourceContainer } from '../../../MoneySource';

interface ISummaryMobile {
  isAutoProlongVisible: boolean;
  autoProlongTooltipText?: string;
  allowMoneySourceWidget: boolean;
}

export const SummaryMobile = ({
  isAutoProlongVisible,
  autoProlongTooltipText,
  allowMoneySourceWidget,
}: ISummaryMobile) => {
  return (
    <div className={classNames(styles['summary'])}>
      {isAutoProlongVisible && (
        <Layout>
          <Layout.Content>
            <AutoProlongContainer />
          </Layout.Content>
        </Layout>
      )}

      {!isAutoProlongVisible && autoProlongTooltipText && (
        <Layout>
          <Layout.Content>
            <UIText1>{autoProlongTooltipText}</UIText1>
          </Layout.Content>
        </Layout>
      )}
      <Layout>
        <Layout.Content>
          {allowMoneySourceWidget && <MoneySourceContainer />}
          <BalanceMobile />
        </Layout.Content>
      </Layout>

      <CheckoutContainer />
      <N1PublicationBannerContainer />
      <MLSNPublicationBannerContainer />
      <VisibleViolationsWarningContainer />
      <ActionButtonsContainer />
    </div>
  );
};
